import React from "react";
import { Card, Header } from "semantic-ui-react";

class Quotes extends React.Component {
  quotes = [
    "Try Again. Fail again. Fail better.",
    "If it matters to you, you’ll find a way",
    "Open your mind. Get up off the couch. Move.",
    "Fall seven times, stand up eight",
    "Every moment is a fresh beginning",
    "Simplicity is the ultimate sophistication",
    "Tough times never last but tough people do",
    "If you tell the truth you don’t have to remember anything.",
    "Don’t you know your imperfections is a blessing? ",
    "To live will be an awfully big adventure.",
    "be a rainbow in someone’s cloud.",
    "When words fail, music speaks.",
    "Smile in trouble",
    "Teeth aren’t pearly, until you smile",
    "Nothing shakes the smiling heart",
    "Be happy for this moment. This moment is your life",
    "The grass is always greener where you water it",
    "Don’t look for society to give you permission to be yourself.",
    "Whatever you are, be a good one",
    "If you’re going through hell, keep going.",
    "Be yourself; everyone else is already taken",
    "In heaven, all the interesting people are missing.",
    "Love cures people – both the ones who give it and the ones who receive it.",
    "Why are you trying so hard to fit in when you were born to stand out?",
    "What does not kill you simply makes you stronger",
    "The flower that blooms in adversity is the most rare and beautiful of all.",
    "You'll have bad times, but it'll always wake you up to the good stuff you weren't paying attention to",
    "Nothing happens to anyone that he is not fitted by nature to bear",
    "Young man, sometimes the right path is not the easiest one.",
    "Hope is a good thing, maybe the best of things, and no good thing ever dies. ",
    "Sometimes, it's the very people who no one imagines anything of who do the things no one can imagine.",
    "It's supposed to be hard.If it wasn't hard, everyone would do it. The hard... is what makes it great",
    "Just keep swimming!",
    "A laugh can be a very powerful thing. Why, sometimes in life, it’s the only weapon we have",
    "All Good Things Take Time",
    "Anything worth doing is worth doing it wrong for the first time.",
    "The problem with having problems is that ‘someone’ always has it worse.",
    "One small crack does not mean that you are broken, it means that you were put to the test and you didn’t fall apart.",
    "Healing takes time, and asking for help is a courageous step.",
    "You are not thrown into the fire, you are the fire.",
    "There is hope, even when your brain tells you there isn’t",
    "We need each other, and the sooner we learn that, the better for us all.",
    "If you are broken, you do not have to stay broken",
    "The dark days make you stronger. Or maybe you already were strong, and they made you prove it.",
    "This feeling will pass. The fear is real but the danger is not",
    "Be patient and tough; some day this pain will be useful to you",
    "Not until we are lost do we begin to understand ourselves",
    "What mental health needs is more sunlight, more candor, and more unashamed conversation",
    "You don’t need to find a lesson in your trauma",
    "Change what you can, manage what you can’t.",
  ];

  randomQuotes = (quotes) => quotes[Math.floor(Math.random() * quotes.length)];

  render() {
    return (
      <Card>
        <Card.Content
          style={{
            backgroundColor: "#4267B2",
            fontSize: 18,
          }}
        >
          <Header as="h3" style={{ color: "white" }}>
            {this.randomQuotes(this.quotes)}
          </Header>
        </Card.Content>
      </Card>
    );
  }
}

export default Quotes;



// WEBPACK FOOTER //
// ./src/components/MetaPanel/Quotes.js